import { HTMLChakraProps, Text } from '@chakra-ui/react';
import { formatDistanceToNow } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useTimeAgo } from '@/hooks/use-time-ago';
import { Comment } from '@/resources/Comment';

export interface ICommentPostedAtProps extends HTMLChakraProps<'div'> {
  comment: Comment;
}

export const CommentPostedAt: FC<ICommentPostedAtProps> = ({ comment, ...rest }) => {
  const { t } = useTranslation();
  const timeAgo = useTimeAgo({ date: new Date(comment.metadata.createdAt), formatter: formatDistanceToNow });

  return (
    <Text as="span" pt={1} pl={2} color="gray.800" fontSize="xs" {...rest}>
      {t('newLecture.relativeTimestamp', {
        time: timeAgo,
      })}
    </Text>
  );
};
